/// <amd-module name="Wit/WorkItemForm/Header/index" />
export * from './WorkItemFormHeader';
